import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';

import { DateTime } from 'luxon';

@MappedClass()
export class GetCityTaxCheckInformationRequest {
  @MappedProperty()
  ownerIstatId: number;

  @MappedProperty()
  istatCustomerIdsToInclude: string[];

  @MappedProperty()
  month: number | null;

  @MappedPropertyDate()
  referenceDate: DateTime | null;

  @MappedProperty()
  year: number | null;

  constructor(init?: Partial<GetCityTaxCheckInformationRequest>) {
    Object.assign(this, init);
  }
}
